import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CHANGEOVER_OF_CARDS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CHANGEOVER_OF_CARDS_REPORT } from "../interfaces/dashboard";

export default function ChangeoverOfCards() {
    const changeoverOfCardsReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CHANGEOVER_OF_CARDS_REPORT;

    const [changeoverOfCardsReportTableData, setChangeoverOfCardsTableData] = useState<CHANGEOVER_OF_CARDS_REPORT[]>([]);

    useEffect(() => {
        setChangeoverOfCardsTableData(CHANGEOVER_OF_CARDS_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="CHANGEOVER_OF_CARDS"
        tableColumns={changeoverOfCardsReportTableColumns}
        tableData={changeoverOfCardsReportTableData} />
    );
}